<template>
  <div class="loginNew">
    <div class="app_icon">
      <img :src="imgUrl" height="100px" width="100px">
    </div>
    <div class="input_con">
      <van-field class="phone_input" v-model="phoneNum"  label="手机号:" placeholder="请输入手机号"></van-field>
      <van-field class="sms_input" v-model="authCode" center clearable label="短信验证码:" placeholder="请输入短信验证码">
        <van-button slot="button" size="small" color="#f47b20" @click="countDown">{{content}}</van-button>
      </van-field>
    </div>
    <div class="but_con">
      <van-button class="bt_reset" color="#f47b20" @click="doLogin">登录/注册</van-button>
    </div>

  </div>
</template>

<script>
import { mySessionStorage } from '@/utils/storage.js'
export default {
  name: 'login',
    data() {
      return {
        checked: false,
        title: "",
        phoneNum: "",
        empCode: "",
        openid:"",
        hint: "",
        authCode: "",
        content: '发送验证码', // 按钮里显示的内容
        totalTime: 60, //记录具体倒计时时间
        canClick: true,
        imgUrl: '../static/img/app_icon.png',
      }
    },
    methods: {
      countDown() {
        if (!this.canClick) {
          return //改动的是这两行代码
        }
        this.canClick = false;
        this.content = this.totalTime + 's后重新发送'
        let clock = window.setInterval(() => {
          this.totalTime--
          this.content = this.totalTime + 's后重新发送'
          if (this.totalTime < 0) {
            window.clearInterval(clock)
            this.content = '重新发送验证码'
            this.totalTime = 60
            this.canClick = true //这里重新开启
          }
        }, 1000);
        this.sendSms();

      },
      sendSms(){
        //调用后台接口发送验证吗
      let params = {
            phone: this.phoneNum        
          };
          console.log(this.phoneNum);
          this.$http
            .post(this.$api.sendMes, params)
            .then(data => {
              console.log("验证码返回", data);
              if (data.code == 200) {
                //console.log(data.data[0].id);
                //成功后自动登录跳转到首页
                this.$toast("验证码发送成功");
                this.hint='验证码已发送到'+this.phoneNum+"手机注意查收";
              }
            })
            .catch(err => {
              console.log(err);
            });

      },
      doLogin() {
        //校验手机号
        if(!this.checkPhone()){
          this.$toast("请输入正确的手机号");
          return;
        }
        if(this.authCode==""||this.authCode==null){
          this.$toast("请输入验证码");
          return;
        }
        let params = {
          phone: this.phoneNum,
          authCode: this.authCode,
          openid:this.openid
        };
        this.$http
          .post(this.$api.loginUrl, params)
          .then(data => {
            console.log("登录返回", data);
            if (data.code == 200) {
              this.$toast("登录成功");
              this.$router.push("myCar");
            }
            else{
              this.$toast(data.msg);
            }
          })
          .catch(res => {
            console.log(res);
            this.$toast("登录失败",res.msg);
          });
      },

      checkPhone(){
        if(!(/^1[3456789]\d{9}$/.test(this.phoneNum))){
          return false;
        }
        else{
          return true;
        }
      },
      getopenId() {
      if (mySessionStorage.getItem("openid") != null && mySessionStorage.getItem("openid") != "" && mySessionStorage.getItem("openid") != "") {
        this.openid = mySessionStorage.getItem("openid");    
      } else {
        this.$getOpenid().then(res => {
          this.openid = mySessionStorage.getItem("openid");
          console.log("--------------------------", this.openid);
        });

      }
    }
    },
    created() {
      
    },
    mounted() {
      this.getopenId();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loginNew {
  width: 100%;
  height: 100%;
  /* float: left; */
  color: rgba(255, 255, 255, 0.95);
  background-color: #f2f2f2;
  position: relative;
}
.app_icon{
    /* padding-top: 60%;  */
    text-align: center;
    padding-top: 160px;
    width: 100%;
    height: 150px;
    /* float: left; */
}
.input_con{
    /* margin-top: 40px; */
    text-align: center;
    width: 98%;
    margin-left: 1%;
    height: calc( 100vh - 380px );
    min-height: 210px;
    /* float: left; */
}
.sms_input{
  margin-top: 12px;
  height: 44px;
  
}
.but_con{
 /* position: fixed; */
 /* bottom: 30px; */
 /* height: 30px; */
 width: 100%;
}
.but_con .van-button{
  width: 98%;
  height: 40px;
  margin-left: 1%;
 
}








</style>



// WEBPACK FOOTER //
// src/components/login.vue